import React from "react";

import { callLink } from "./ChooseProductSection.constants";

export const HealthList = [
  {
    id: 1,
    links: [
      {
        ...callLink,
        title: "3003 0085",
        description: (
          <>
            Capitais e regiões metropolitanas. Atendimento 24h, todos os dias.
          </>
        ),
        id: "1-link",
        href: "tel:3003 0085",
      },
    ],
  },
  {
    id: 2,
    links: [
      {
        icon: callLink.icon,
        title: "0800 710 0085",
        id: "2-link",
        href: "tel:0800 710 0085",
        description: (
          <>
            Para as demais regiões do Brasil, a ligação é gratuita. Atendimento
            24h, todos os dias.{" "}
          </>
        ),
      },
    ],
  },
];
